import { grey, teal } from '@mui/material/colors';
import { makeStyles } from 'tss-react/mui';
import Typography from '@mui/material/Typography';
import React from 'react';
import SubHeader from './SubHeader';
import Balancer from 'react-wrap-balancer';

const PostTitle = props => {
  const useStyles = makeStyles()(theme => {
    return {
      root: {
        minHeight: props.isPreview ? '300px' : '550px',
        padding: '10px',
      },
      title: {
        color: '#F3F4F7',
        fontSize: '2.7rem',
        [theme.breakpoints.up('sm')]: {
          fontSize: '3.5rem',
          padding: '0 30px',
        },
        [theme.breakpoints.up('lg')]: {
          fontSize: '4rem',
          padding: '0 50px',
        },
      },
      badge: {
        background: teal[600],
        color: grey[200],
      },
    };
  });
  const { classes } = useStyles();

  return (
    <div className="container">
      <div className={`row ${classes.root}`}>
        <div className="text-center col my-auto">
          <Typography
            variant="h2"
            className={`tw-font-extrabold ${classes.title}`}
            component="h1"
          >
            <Balancer>{props.title}</Balancer>
          </Typography>
          <div className="pt-3">
            <Typography
              color="textPrimary"
              variant="overline"
              className="font-weight-bold p-2 tw-text-gray-200"
            >
              <SubHeader
                createdAt={
                  props.createdAt ? String(props.createdAt) : undefined
                }
                readTime={props.readTime}
                wordCount={props.wordCount}
                // community={props.community}
                location={props.location}
                hideLocationIcon
                isWhite
              />
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostTitle;
